import { axiosInstance, getErrorStatus } from './axiosInstance';
import { StatusCodes } from 'http-status-codes';
import { handleErrorResponse } from '../../helpers/handleErrorResponse';

const POSTFIX = '/applications';

export const submitBusinessApplication = async () => {
  let response;

  const businessId = localStorage.getItem('businessId');

  try {

    response = await axiosInstance.post(`/business-applications/${businessId}/applications`);

  } catch (err) {

    response = {
      data: {
        traceId: err?.response?.headers?.['x-amzn-trace-id'] || '',
        error: {
          ...(err || {}),
          status: getErrorStatus(err)
        }
      }
    };
  }

  return response;
};

export const getApplicationsByBusinessId = async (businessId) => {
  let response;

  try {
    if (businessId) {
      response = await axiosInstance.get(`/business-applications/${businessId}/applications`);
    } else {
      response = {};
    }

  } catch (err) {
    response = handleErrorResponse(err);
  }
  return response;
};

export const getApplications = async () => {

  let response;

  try {

    response = await axiosInstance.get(POSTFIX);

    if (response.status !== StatusCodes.OK || !response.data) {

      throw new Error('GetApplications');
    }

  } catch (error) {

    const errorResponse = error.response || {};

    if (errorResponse.status === StatusCodes.NOT_FOUND) {
      response = { data: null };
    } else {
      throw error;
    }
  }

  return response.data;
};

export const getApplication = async (applicationId) => {

  let response;

  try {

    response = await axiosInstance.get(`${POSTFIX}?applicationId=${applicationId}`);

    if (response.status !== StatusCodes.OK || !response.data) {

      throw new Error('GetApplication');
    }

  } catch (error) {

    const errorResponse = error.response || {};

    if (errorResponse.status === StatusCodes.NOT_FOUND) {
      response = { data: null };
    } else {
      throw error;
    }
  }

  return response.data;
};

export const checkApplicationExistsByBusinessIdNumber = async (businessIdNumber) => {
  let response;
  const bodyData = {
    'businessIdNumber': businessIdNumber
  };

  try {
    response = await axiosInstance.post('/business-applications/business/businessIdNumber', bodyData);
  } catch (err) {

    response = {
      data: {
        traceId: err?.response?.headers?.['x-amzn-trace-id'] || '',
        error: {
          ...(err || {}),
          status: getErrorStatus(err)
        }
      }
    };
  }

  return response;
};